import axios from "axios";

export const createPlanSubmission = (submissionType, projectRootFolderId) =>
  axios.post("/api/e-counter/planSubmission", {
    projectRootFolderId,
    submissionType
  });

export const getProjects = (filter) =>
  axios.get(`/ess/api/e-counter/project/?filter=${filter}`);

export const getProjectsWithProperties = (filter) =>
  axios.get("/api/e-counter/projectWtihProperties", {
    params: {
      filter
    }
  });

export const createForm = (formName, submissionFolderId) =>
  axios.post(`/api/e-counter/planSubmission/form`, {
    formName,
    folderId: submissionFolderId
  });

export const createConsentSubmissionBA11 = (projectRootFolderId) => {
  return axios.post(`api/e-counter/Selectcement`, {
    projectRootFolderId
  });
};

export const getForms = (submissionFolderId, formName) =>
  axios.get(`/api/e-counter/planSubmission/${submissionFolderId}/form`, {
    params: {
      formName
    }
  });

export const getProjectSubmissions = () =>
  axios.get(`/ess/api/workspace?Page=0&Size=100`);

export const summarizeConsentBA9 = (folderID) => {
  return axios.get(`api/e-counter/renewalconsent/${folderID}/summary`);
};

export const getProjectSubmissionsByFilter = (filter) =>
  axios.get(`/api/workspace`);

export const preview = (submissionFolderId) =>
  axios.get(`/api/e-counter/planSubmission/${submissionFolderId}/preview`);

export const submitPlanSubmission = (submissionfolderid) => {
  return axios.post(
    `/api/e-counter/planSubmission/${submissionfolderid}/submit`
  );
};

export const getTransaction = (submissionfolderid) => {
  return axios.get(`/api/e-counter/transaction/${submissionfolderid}`);
};

//commencemen
export const createCommencementSubmission = (projectRootFolderId) =>
  axios.post("/ess/api/e-counter/commencement", {
    ESSProjectID: projectRootFolderId
  });

// export const createCommencementSubmission = (projectRootFolderId) =>
//   axios.post("/api/e-counter/commencement", {
//     projectRootFolderId
//   });

export const getConsentApprovedPlans = (submissionfolderid) => {
  return axios.get(`/api/e-counter/consent/${submissionfolderid}/plans`);
};

export const getCommencementGrantedConsent = (submissionfolderid) => {
  return axios.get(
    `/api/e-counter/commencement/${submissionfolderid}/selectGrantedConsent`
  );
};

export const getCpnsentApprovedPlansBA9 = (submissionfolderid) => {
  return axios.get(
    `api/e-counter/renewalconsent/${submissionfolderid}/selectRenewalGrantedConsent`
  );
};

export const postConsentApprovedPlans = (submissionfolderid, approvedPlans) => {
  return axios.post(
    `/api/e-counter/consent/${submissionfolderid}/selectApprovedPlans`,
    approvedPlans
  );
};

export const getpreviewBA11 = (submissionfolderid) => {
  return axios.get(`/api/e-counter/Selectcement/${submissionfolderid}/preview`);
};

export const postConsentApprovedPlansBA9 = (
  folderID,
  approvedPlans = {
    Plans: [
      {
        PlanSubmissionID: 0,
        Partial: true,
        Notes: "string",
        FileID: 0
      }
    ]
  }
) => {
  return axios.post(
    `/api/e-counter/renewalconsent/${folderID}/selectApprovedPlans`,
    approvedPlans
  );
};
//BA10 Consent list
export const postCommencementApprovedConsent = (
  submissionfolderid,
  approvedPlans
) => {
  return axios.post(
    `/api/e-counter/commencement/${submissionfolderid}/selectApprovedPlans`,

    approvedPlans
  );
};

export const getCeasingConsentPlansBA11 = (projectRootFolderID) => {
  return axios.get(
    `/api/e-counter/Selectcement/${projectRootFolderID}/selectConsent`
  );
};

export const postConsentApprovedPlansBA11 = (
  projectRootFolderID,
  approvedPlans
) => {
  return axios.get(
    `api/folders/${projectRootFolderID}/list/all?type=VirtualDocument`,

    approvedPlans
  );
};

export const getConsentConditions = (submissionId) => {
  return axios.get(`/ess/api/e-counter/consent-submission/${submissionId}/consent-conditions`);
};

export const postConsentConditions = (submissionId, conds) => {
  return axios.put(
    `/ess/api/e-counter/consent-submission/${submissionId}/consent-conditions`,
    conds
  );
};

//summarizeCommencement
export const summarizeCommencement = (submissionfolderid) => {
  return axios.get(`/api/e-counter/commencement/${submissionfolderid}/summary`);
};

//summarizeCeasing
export const summarizeCeasing = (submissionfolderid) => {
  return axios.get(`/api/e-counter/Selectcement/${submissionfolderid}/summary`);
};

export const summarizeCommencementBA11 = (submissionfolderid) => {
  return axios.get(`api/e-counter/Selectcement/${submissionfolderid}/summary`);
};

export const summarizeConsent = (submissionfolderid) => {
  return axios.get(`/api/e-counter/consent/${submissionfolderid}/summary`);
};

export const submitOther = (submissionId) => {
  return axios.post(
    `ess/api/e-counter/other-submission/${submissionId}/submit`
  );
};

// completion
export const createCompletionSubmission = (ESSProjectID) =>
  axios.post("/ess/api/e-counter/completion-submission", {
    ESSProjectID
  });

export const createOtherSubmission = (projectRootFolderId) =>
  axios.post("/ess/api/e-counter/other-submission/new", {
    ESSProjectID: projectRootFolderId,
    ECMProjectID: projectRootFolderId
  });

export const getCompletionApprovedPlans = (submissionfolderid) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/plans`
  );
};

export const getBA9CompletionApprovedPlans = (folderID) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${folderID}/plans`
  );
};

export const postCompletionApprovedPlans = (
  submissionfolderid,
  approvedPlans
) => {
  return axios.post(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/selectApprovedPlans`,
    approvedPlans
  );
};

export const getCompletionConditions = (submissionfolderid) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/condition`
  );
};

export const postCompletionConditions = (submissionfolderid, conds) => {
  return axios.put(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/condition`,
    conds
  );
};

export const previewCompletion = (submissionfolderid) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/preview`
  );
};

export const summarizeCompletion = (submissionfolderid) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/summary`
  );
};

export const submitCompletion = (submissionfolderid) => {
  return axios.post(
    `/ess/api/e-counter/completion-submission/${submissionfolderid}/submit`
  );
};

export const searchProject = (searchContent) => {
  //asd
  return axios.get(`/ecm/api/e-directoy/`);
  //return axios.get(`/api/e-counter?filter=${searchContent}`);
};

export const exportFileMetaDataCSV = (submissionFolderId, csvFile) => {
  let formData = new FormData();
  formData.append("files", csvFile);
  return axios.post(
    `/api/e-counter/import/${submissionFolderId}/metaData`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

/**
 * Get permission
 * @param {String} folderId Project or submission folder id
 */
export const getPermission = (folderId) =>
  axios.get(`/api/e-counter/${folderId}/permission/`);

/**
 * Get permission
 * @param {String} folderId Project or submission folder id
 */
export const savePermission = (folderId, payload) =>
  axios.put(`/api/e-counter/${folderId}/permission`, payload);

export const setSubmissionValidateFlag = (folderId) =>
  axios.put(`/ess/api/e-counter/submission/${folderId}/validateflag`);

export const getSubmissionValidateFlag = (folderId) =>
  axios.get(`/ess/api/e-counter/submission/${folderId}/validateflag`);

export const validatePlanSubmission = (folderId) =>
  axios.get(`/api/e-counter/planSubmission/${folderId}/validate`);

export const validateConsentSubmission = (folderId) =>
  axios.get(`/api/e-counter/consent/${folderId}/validate`);

export const validateCompletionSubmission = (folderId) =>
  axios.get(`/ess/api/e-counter/completion-submission/${folderId}/validate`);

export const validateCommencementSubmission = (folderId) =>
  axios.get(`/api/e-counter/commencement/${folderId}/validate`);

export const validateRenewalconsentSubmission = (folderId) =>
  axios.get(`/api/e-counter/renewalconsent/${folderId}/validate`);

export const validateSelectcementSubmission = (folderId) =>
  axios.get(`/api/e-counter/Selectcement/${folderId}/validate`);

export const autofillPlanSubmission = (folderId) =>
  axios.post(`/api/e-counter/planSubmission/${folderId}/autoFill`);

//prepare letter
export const getAllLetterTemplates = () =>
  axios.get(`/api/eps/letter/lettertemplate`);

export const getSentLetters = () => axios.get(`/api/eps/letter/sentletter`);

export const saveLetter = (payload) =>
  axios.post(`/api/eps/letter/save`, payload);

export const getLetter = (letterId) =>
  axios.get(`/api/eps/letter/${letterId}/prepareletter`);

export const getAppendixTemplateList = () =>
  axios.get(`/api/eps/letter/appendixtemplate`);

export const getAppendixByTemplateId = (appendixTemplateId) =>
  axios.get(`/api/eps/letter/${appendixTemplateId}/appendix`);

export const getOtherSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/other-submission/${submitId}`);

export const updateOtherSubmission = (submitId, data) => {
  return axios.put(`/ess/api/e-counter/other-submission/${submitId}`, data);
};
export const updateCompletionSubmission = (submitId, data) => {
  return axios.put(
    `/ess/api/e-counter/completion-submission/${submitId}`,
    data
  );
};

export const previewOtherSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/other-submission/${submitId}/preview`);

export const getSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/submission/${submitId}`);

export const getCompletionSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/completion-submission/${submitId}`);

export const getECMPlanSubmissionByProjectId = (projectId) =>
  axios.get(
    `/ecm/api/e-counter/plan-submission/getByProjectId?projectId=${projectId}`
  );

export const getECMPlanByProjectId = (projectId) =>
  axios.get(`/ecm/api/e-counter/plan/getByProjectId?projectId=${projectId}`);

export const createConsentSupplementSubmission = (projectId, SubmissionId) =>
  axios.post("/ess/api/e-counter/consent-submission/createSupplement", {
    ESSProjectID: projectId,
    ECMPlanID: SubmissionId
  });
  export const createCompletionSupplementSubmission = (projectId, SubmissionId) =>
  axios.post("/ess/api/e-counter/completion-submission/createSupplement", {
    ESSProjectID: projectId,
    ECMPlanID: SubmissionId
  });
  
export const getPlanConsentConditions = (submitId) => {
  return axios.get(
    `/ess/api/e-counter/consent-submission/supplementConditions?submissionId=${submitId}`
  );
};
export const getPlanCompletionConditions = (submitId) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/supplementConditions?submissionId=${submitId}`
  );
};

export const savePlanConsentConditions = (submitId, conds) => {
  return axios.put(
    `ess/api/e-counter/consent-submission/supplementConditions/${submitId}/save`,
    conds
  );
};
export const savePlanCompletionConditions = (submitId, conds) => {
  return axios.put(
    `ess/api/e-counter/completion-submission/supplementConditions/${submitId}/save`,
    conds
  );
};
export const previewConsentSupplementSubmission = (submitId) => {
  return axios.get(
    `/ess/api/e-counter/consent-submission/${submitId}/preview-consent-supplement`
  );
};
export const previewCompletionSupplementSubmission = (submitId) => {
  return axios.get(
    `/ess/api/e-counter/completion-submission/${submitId}/preview-completion-supplement`
  );
};

export const submitConsentSupplement = (submissionId) => {
  return axios.post(
    `ess/api/e-counter/consent-submission/${submissionId}/submit-consent-supplement`
  );
};

export const createConsentSubmission = (projectId) =>
  axios.post("/ess/api/e-counter/consent-submission/create", {
    ESSProjectID: projectId
  });

export const getConsentSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/consent-submission/${submitId}`);


  export const getConsentSupplementSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/consent-submission/${submitId}`);


  

export const updateConsentSubmission = (submitId, data) => {
  return axios.put(`/ess/api/e-counter/consent-submission/${submitId}`, data);
};

export const getConsentApprovalList = (submitId) =>
  axios.get(
    `/ess/api/e-counter/consent-submission/${submitId}/approved-planlist`
  );

export const setConsentApprovalList = (submitId,data) => {
  return axios.put(`/ess/api/e-counter/consent-submission/${submitId}/select-plans`, data);
};

export const getCommencementSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/commencement/${submitId}`);

export const updateCommencementSubmission = (submitId, data) => {
  return axios.put(`/ess/api/e-counter/Commencement/${submitId}`, data);
};

export const createConsentRenewalSubmission = (projectId) =>
  axios.post("/ess/api/e-counter/consent-renewal", {
    ESSProjectID: projectId
  });
export const getConsentRenewalSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/consent-renewal/${submitId}`);

export const updateConsentRenewalSubmission = (submitId, data) => {
  return axios.put(`/ess/api/e-counter/consent-renewal/${submitId}`, data);
};

export const createCeasingSubmission = (projectId) =>
  axios.post("/ess/api/e-counter/ceasing", {
    ESSProjectID: projectId
  });
export const getCeasingSubmission = (submitId) =>
  axios.get(`/ess/api/e-counter/ceasing/${submitId}`);

export const updateCeasingSubmission = (submitId, data) => {
  return axios.put(`/ess/api/e-counter/ceasing/${submitId}`, data);
};

export const previewConsentRenewal = (submitId) => {
  return axios.get(`/ess/api/e-counter/consent-renewal/${submitId}/preview`);
};
export const submitConsentRenewal = (submitId) => {
  return axios.post(`/ess/api/e-counter/consent-renewal/${submitId}/submit`);
};

export const previewConsent = (submitId) => {
  return axios.get(`/ess/api/e-counter/consent-submission/${submitId}/preview`);
};
export const submitConsent = (submitId) => {
  return axios.post(`/ess/api/e-counter/consent-submission/${submitId}/submit`);
};

export const previewCeasing = (submitId) => {
  return axios.get(`/ess/api/e-counter/ceasing/${submitId}/preview`);
};
export const submitCeasing = (submitId) => {
  return axios.post(`/ess/api/e-counter/ceasing/${submitId}/submit`);
};

export const previewCommencement = (submitId) => {
  return axios.get(`/ess/api/e-counter/commencement/${submitId}/preview`);
};
export const submitCommencement = (submitId) => {
  return axios.post(`/ess/api/e-counter/commencement/${submitId}/submit`);
};
